export default {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  PINTEREST: 'pinterest',
  TUMBLR: 'tumblr',
  LINK: 'link'
};
export const shareMappingPath = '_api/media-share-server-for-video';
//# sourceMappingURL=social-networks.js.map